import Vue from 'vue'
import BattleDialog from './src/main'
if (BattleDialog) {
  BattleDialog.install = (options) => {
    if (options.data.visible) {
      let div = document.getElementById('BattleDialog')
      let div1 = document.querySelector('.battleDialog')
      let div2 = document.querySelector('.v-modal')
      if (div) {
        document.body.removeChild(div)
      }
      if (div1) {
        document.body.removeChild(div1)
      }
      if (div2) {
        document.body.removeChild(div2)
      }
      return
    }
    if (document.querySelector('.battleDialog')) {
      return
    }
    const AlterBox = Vue.extend(BattleDialog)
    let instance = new AlterBox({
      ...options
    }).$mount()
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.visible = true
      // show 和弹窗组件里的show对应，用于控制显隐
    })
  }
}
export default BattleDialog



// WEBPACK FOOTER //
// ./src/plugin/BattleDialog/index.js